import Vue from 'vue';
import VueRouter from 'vue-router';
import Lance from '../views/lance';
import Lotes from '../views/lotes';
import Leiloes from '../views/leiloes/Leiloes.vue';
import Login from '../views/login';
import Cadastro from '../views/cadastro';
import ReenviarConfirmacaoEmail from '../views/login/reenviar-confirmacao-email';
import Dashboard from '../views/dashboard';
import ErrorPage from '../views/error';
import mainOidc from '../service/oidc';
import Home from '../views/home';
import store from '../store';
import middleware from './middleware';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    meta: { requiresAuth: false },
    component: Home
  },
  {
    path: '/lotes/:leilaoId',
    name: 'lotesId',
    meta: { requiresAuth: false },
    component: Lotes,
    props: true
  },
  {
    path: '/lotes',
    name: 'lotes',
    meta: { requiresAuth: false },
    component: Lotes
  },
  {
    path: '/lote/:loteId',
    name: 'Lote',
    meta: { requiresAuth: false },
    component: Lance,
    props: true
  },
  {
    path: '/pesquisa',
    name: 'pesquisa',
    meta: { requiresAuth: false },
    component: () => import('@/views/lotes/components/LotesPesquisa.vue')
  },
  {
    path: '/leiloes',
    name: 'leiloes',
    meta: { requiresAuth: false },
    component: Leiloes
  },
  {
    path: '/login',
    name: 'login',
    meta: { requiresAuth: false },
    component: Login
  },
  {
    path: '/cadastro',
    name: 'cadastro',
    meta: { requiresAuth: false },
    component: Cadastro
  },
  {
    path: '/reenviar-confirmacao-email',
    name: 'reenviar-confirmacao-email',
    meta: { requiresAuth: false },
    component: ReenviarConfirmacaoEmail
  },
  // {
  //   path: '/empresa',
  //   name: 'empresa',
  //   meta: { requiresAuth: false },
  //   component: () => import('@/views/estaticas/empresa.vue'),
  // },
  // {
  //   path: '/entrega',
  //   name: 'entrega',
  //   meta: { requiresAuth: false },
  //   component: () => import('@/views/estaticas/entrega.vue'),
  // },
  // {
  //   path: '/termos-de-uso',
  //   name: 'termodeuso',
  //   meta: { requiresAuth: false },
  //   component: () => import('@/views/estaticas/termodeuso.vue'),
  // },
  // {
  //   path: '/quero-vender',
  //   name: 'querovender',
  //   meta: { requiresAuth: false },
  //   component: () => import('@/views/estaticas/querovender.vue'),
  // },
  // {
  //   path: '/politica-privacidade',
  //   name: 'politicaprivacidade',
  //   meta: { requiresAuth: false },
  //   component: () => import('@/views/estaticas/politicaprivacidade.vue'),
  // },
  // {
  //   path: '/politica-cookies',
  //   name: 'politicacookies',
  //   meta: { requiresAuth: false },
  //   component: () => import('@/views/estaticas/politicacookies.vue'),
  // },
  // {
  //   path: '/politica-de-seguranca',
  //   name: 'politicasegurancainformacao',
  //   meta: { requiresAuth: false },
  //   component: () => import('@/views/estaticas/politicasegurancainformacao.vue'),
  // },
  // {
  //   path: '/como-funciona',
  //   name: 'comofunciona',
  //   meta: { requiresAuth: false },
  //   component: () => import('@/views/estaticas/comofunciona.vue'),
  // },
  {
    path: '/fatura/:faturaToken',
    name: 'Fatura',
    meta: { requiresAuth: false },
    component: () => import('@/views/fatura/index.vue')
  },
  {
    path: '/conta',
    name: 'Conta',
    meta: { requiresAuth: true },
    component: Dashboard,
    children: [
      {
        path: 'perfil',
        name: 'perfil',
        component: () => import('@/views/dashboard/perfil')
      },
      {
        path: 'edit-perfil',
        name: 'edit-perfil',
        component: () => import('@/views/dashboard/edit-perfil')
      },
      {
        path: 'lotesarrematados',
        name: 'lotesarrematados',
        component: () => import('@/views/dashboard/agendamento')
      },
      {
        path: 'trocar-senha',
        name: 'Trocar Senha',
        component: () => import('@/views/dashboard/trocar-senha')
      },
      {
        path: 'seguranca',
        name: 'seguranca',
        component: () => import('@/views/dashboard/seguranca')
      },
      {
        path: 'notificacoes',
        name: 'notificacoes',
        component: () => import('@/views/dashboard/notificacoes')
      }
    ]
  },
  {
    path: '/pagina/:pagina',
    name: 'paginaEstatica',
    meta: { requiresAuth: false },
    component: () => import('@/views/paginaEstatica/index.vue')
  },
  {
    path: '/validar',
    name: 'validacaodocumento',
    meta: { requiresAuth: false },
    component: () => import('@/views/validacaodocumento/index.vue')
  },
  {
    path: '/validar/:id',
    name: 'validacaodocumentoid',
    meta: { requiresAuth: false },
    component: () => import('@/views/validacaodocumento/index.vue')
  },

  {
    path: '/:slug',
    name: 'leiloeiro',
    meta: { requiresAuth: false },
    component: () => import('@/views/leiloeiro/index.vue'),
    props: true
  },
  {
    path: '*',
    name: 'error',
    component: ErrorPage
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Evita rolar ao topo quando apenas a query muda (mesma rota)
    const samePath = to.path === from.path;
    const queryChanged = JSON.stringify(to.query || {}) !== JSON.stringify(from.query || {});
    const hashChanged = (to.hash || '') !== (from.hash || '');
    if (samePath && queryChanged && !hashChanged) {
      return false; // mantém posição atual
    }
    // Restaura posição do browser
    if (savedPosition) return savedPosition;
    // Com hash, tenta rolar até o seletor
    if (to.hash) return { selector: to.hash };
    // Padrão: topo
    return { x: 0, y: 0 };
  }
});

mainOidc.useRouter(router);

// `cadastro` (usuarioInfo/mfaRequired) não é persistido pelo vuex-persistedstate — só `login`,
// `categoria` e `paginas` são. Ou seja: ao dar F5 / abrir o host direto, registerCompleted volta
// `true` do localStorage mas usuarioInfo volta vazio. Por isso NÃO basta checar registerCompleted
// para decidir se busca usuario/info de novo: precisa buscar pelo menos uma vez por boot do app.
let mfaInfoFetchedThisBoot = false;

router.beforeEach(async function (to, _, next) {
  const hasAuth = !!store.getters['getAuth'] && !store.state.login.pendingSocialAuth;
  const isMfaForcedPath = (path) => {
    const p = String(path || '').toLowerCase();
    return p.startsWith('/conta/seguranca') || p === '/conta/seguranca';
  };
  const isLogoutPath = (path) => {
    const p = String(path || '').toLowerCase();
    return p === '/logout' || p.startsWith('/logout');
  };

  // 1. Usuário AUTENTICADO com cadastro COMPLETO, MFA OBRIGATÓRIO (definido pelo admin) e ainda
  // não ativo → FICA PRESO NA TELA SEGURANÇA. A trava vale para QUALQUER rota (inclusive as
  // públicas como /, /leiloes, /lotes). Únicas rotas de escape: a própria tela de Segurança e o /logout.
  // Fonte da verdade: usuario/Info (mfaRequired + mfaEnabled), carregado por checkRegisterCompleted.
  // Usuários sem cadastro completo NÃO são presos aqui — passam para a regra de cadastro abaixo.
  if (hasAuth && (!mfaInfoFetchedThisBoot || !store.getters.getRegisterCompleted)) {
    try {
      await store.dispatch('checkRegisterCompleted');
      mfaInfoFetchedThisBoot = true;
    } catch (_) {
      void _;
    }
  }
  const registerCompleted = !!(store.getters['getRegisterCompleted'] || store.getters.getRegisterCompleted);
  if (hasAuth && registerCompleted && !isMfaForcedPath(to.path) && !isLogoutPath(to.path)) {
    const info = store.getters['getUsuarioInfo'] || store.state.cadastro?.usuarioInfo || {};
    if (info.mfaRequired && !info.mfaEnabled) {
      next({ name: 'seguranca' });
      return;
    }
  }

  // 🔥 Se já está autenticado e está tentando acessar /login → redireciona para tela principal
  // Resolve callback OIDC Google/Facebook (redirect full page recarrega app do zero)
  // Excessão: cadastroConcluido=1 → deixa passar para mostrar mensagem de confirmação de email
  if (hasAuth && (to.path === '/login' || to.name === 'login') && to.query.cadastroConcluido !== '1') {
    try {
      // Garante cadastroCompleto/usuarioInfo carregados após reload do OIDC
      if (!store.getters.getRegisterCompleted) {
        await store.dispatch('checkRegisterCompleted').catch(() => null);
      }
      const info = store.getters['getUsuarioInfo'] || store.state.cadastro?.usuarioInfo || {};
      if (info && info.cadastroCompleto && info.ativo === false) {
        // Usuário inativo: deixa passar (tela de login vai mostrar aviso)
        next();
        return;
      }
      const redirectUrl = to.query.returnUrl ? decodeURIComponent(to.query.returnUrl) : '/';
      next(redirectUrl);
      return;
    } catch (err) {
      // Em caso de erro, deixa passar (a tela de login mostra o estado)
      next();
      return;
    }
  }

  if (store.getters.getAuth && !store.getters.getRegisterCompleted) {
    if (to.path.includes('cadastro')) {
      next();
      return;
    } else {
      next({ path: '/cadastro' });
      return;
    }
  }

  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (store.getters.getAuth && middleware(store.getters.getAuth.access_token)) {
      next();
    } else {
      next({ path: '/login', query: { returnUrl: to.fullPath } });
    }
  } else {
    next();
  }
});
export default router;
